module.exports = __webpack_public_path__ + "static/media/Hotel.05dc72c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/share/Hotel.png
// module id = 365
// module chunks = 0